import _ from 'lodash'

import { SearchCompany } from '../../redux/search'

export function formatRegistrationNumber(company: SearchCompany) {
  return `${company.registrationNumber ?? ''}${
    company.oldRegistrationNumber ? ` (${company.oldRegistrationNumber})` : ''
  }`
}

export function formatYear(str?: string) {
  return str ? _.toString(new Date(str).getFullYear()) : ''
}

export function formatAddress(company: SearchCompany) {
  return company.hqAddress?.street && company.hqAddress?.houseNumber
    ? `${company.hqAddress?.street} ${company.hqAddress?.houseNumber}`
    : company.hqAddress?.fullAddress
      ? company.hqAddress?.fullAddress
      : ''
}
